import React from "react";
import RichTextEditor from "../../organisms/RichTextEditor/RichTextEditor";

interface DictationOutputProps {
  finalDisplayedTranscript: string;
  finalTranscript: string;
  interimTranscript: string;
}

const DictationOutput = (props: DictationOutputProps) => {
  const { finalDisplayedTranscript, finalTranscript, interimTranscript } =
    props;

  if (finalDisplayedTranscript && finalTranscript) {
    return null;
  }

  return (
    <div className="dui-stt-report">
      {finalDisplayedTranscript && (
        <RichTextEditor
          markdown={finalDisplayedTranscript}
          wrapperClassName="dui-stt-editor"
        ></RichTextEditor>
      )}

      {finalTranscript}
      {interimTranscript && (
        <span style={{ opacity: 0.5 }}>{interimTranscript}</span>
      )}
    </div>
  );
};

export default DictationOutput;
